import React from 'react';
import { useSelector } from 'react-redux'
import Messages from '../Home/components/Messages';
import Communications from 'screens/Communications';
import {
  MessagesScreenContainer,
  Content,
  Container,
} from './styles';

const MessagesScreen = ({mobile, open}) => {

  const selectedGuest = useSelector(state => state.selectReducer.selectedGuest)

  return (
    <>
      <MessagesScreenContainer mobile={mobile} open={open}>
        <Content>
          <Container>  
            <Messages mobile/>
          </Container>
        </Content>
      </MessagesScreenContainer>
      {
        selectedGuest? (
          <Communications
            mobile
            open={open}
          />
        ): null
      }
    </>
  )
}

export default MessagesScreen;
